import "core-js/modules/es6.string.small";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import UrlParse from 'url-parse';
import times from 'lodash/times';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/flechounette.svg';
import { EMPTY_PIXEL } from '~/const/images';
import { formatPrismicImage } from '~/helpers/image-helper';
import TrendBlockDispatch from '~/components/molecules/Editorial/Trend/TrendBlockDispatch.vue';

const GlobalRichText = () => import(
/* webpackChunkName:"global-editorial" */
'~/components/atoms/Editorial/Global/GlobalRichText.vue');

export default {
  name: 'TrendDispatch',
  components: {
    TrendBlockDispatch,
    GlobalRichText
  },
  props: {
    payload: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      mobile: true
    };
  },

  computed: {
    currentPayload() {
      var _ref18, _ref19, _ref20, _ref21;

      return {
        topField: {
          title: ((_ref21 = this.payload) != null ? (_ref21 = _ref21.primary) != null ? _ref21.title : _ref21 : _ref21) || '',
          subtitle: ((_ref20 = this.payload) != null ? (_ref20 = _ref20.primary) != null ? _ref20.subtitle : _ref20 : _ref20) || '',
          paragraph: ((_ref19 = this.payload) != null ? (_ref19 = _ref19.primary) != null ? _ref19.paragraph : _ref19 : _ref19) || ''
        },
        infoPlus: ((_ref18 = this.payload) != null ? (_ref18 = _ref18.primary) != null ? _ref18.info_plus : _ref18 : _ref18) || '',
        trends: times(this.payload.items.length, Number).map(i => {
          var _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17;

          return {
            image: {
              small: formatPrismicImage((_ref17 = this.payload) != null ? (_ref17 = _ref17.items) != null ? (_ref17 = _ref17[i]) != null ? (_ref17 = _ref17.image) != null ? (_ref17 = _ref17.small) != null ? _ref17.url : _ref17 : _ref17 : _ref17 : _ref17 : _ref17) || EMPTY_PIXEL,
              medium: formatPrismicImage((_ref16 = this.payload) != null ? (_ref16 = _ref16.items) != null ? (_ref16 = _ref16[i]) != null ? (_ref16 = _ref16.image) != null ? (_ref16 = _ref16.medium) != null ? _ref16.url : _ref16 : _ref16 : _ref16 : _ref16 : _ref16) || EMPTY_PIXEL,
              large: formatPrismicImage((_ref15 = this.payload) != null ? (_ref15 = _ref15.items) != null ? (_ref15 = _ref15[i]) != null ? (_ref15 = _ref15.image) != null ? (_ref15 = _ref15.large) != null ? _ref15.url : _ref15 : _ref15 : _ref15 : _ref15 : _ref15) || EMPTY_PIXEL
            },
            alt: ((_ref14 = this.payload) != null ? (_ref14 = _ref14.items) != null ? (_ref14 = _ref14[i]) != null ? _ref14.alt : _ref14 : _ref14 : _ref14) || '',
            video: formatPrismicImage((_ref13 = this.payload) != null ? (_ref13 = _ref13.items) != null ? (_ref13 = _ref13[i]) != null ? (_ref13 = _ref13.video) != null ? _ref13.url : _ref13 : _ref13 : _ref13 : _ref13, [], '', 'video') || '',
            backgroundColor: ((_ref12 = this.payload) != null ? (_ref12 = _ref12.items) != null ? (_ref12 = _ref12[i]) != null ? _ref12.background_color : _ref12 : _ref12 : _ref12) || '',
            title: ((_ref11 = this.payload) != null ? (_ref11 = _ref11.items) != null ? (_ref11 = _ref11[i]) != null ? _ref11.title : _ref11 : _ref11 : _ref11) || '',
            subtitle: ((_ref10 = this.payload) != null ? (_ref10 = _ref10.items) != null ? (_ref10 = _ref10[i]) != null ? _ref10.subtitle : _ref10 : _ref10 : _ref10) || '',
            buttonText: ((_ref9 = this.payload) != null ? (_ref9 = _ref9.items) != null ? (_ref9 = _ref9[i]) != null ? _ref9.button_text : _ref9 : _ref9 : _ref9) || '',
            buttonUrl: new UrlParse(((_ref8 = this.payload) != null ? (_ref8 = _ref8.items) != null ? (_ref8 = _ref8[i]) != null ? (_ref8 = _ref8.button_url) != null ? _ref8.url : _ref8 : _ref8 : _ref8 : _ref8) || '').pathname,
            backgroundColorDate: ((_ref7 = this.payload) != null ? (_ref7 = _ref7.items) != null ? (_ref7 = _ref7[i]) != null ? _ref7.background_color_date : _ref7 : _ref7 : _ref7) || '',
            dateLabel: ((_ref6 = this.payload) != null ? (_ref6 = _ref6.items) != null ? (_ref6 = _ref6[i]) != null ? _ref6.date_label : _ref6 : _ref6 : _ref6) || '',
            date: ((_ref5 = this.payload) != null ? (_ref5 = _ref5.items) != null ? (_ref5 = _ref5[i]) != null ? _ref5.date : _ref5 : _ref5 : _ref5) || '',
            imgText: ((_ref4 = this.payload) != null ? (_ref4 = _ref4.items) != null ? (_ref4 = _ref4[i]) != null ? _ref4.img_text : _ref4 : _ref4 : _ref4) || '',
            tracking: {
              data: {
                event_category: ((_ref3 = this.payload) != null ? (_ref3 = _ref3.items) != null ? (_ref3 = _ref3[i]) != null ? _ref3.event_category : _ref3 : _ref3 : _ref3) || '',
                event_action: ((_ref2 = this.payload) != null ? (_ref2 = _ref2.items) != null ? (_ref2 = _ref2[i]) != null ? _ref2.event_action : _ref2 : _ref2 : _ref2) || '',
                event_label: ((_ref = this.payload) != null ? (_ref = _ref.items) != null ? (_ref = _ref[i]) != null ? _ref.event_label : _ref : _ref : _ref) || ''
              }
            }
          };
        })
      };
    },

    pair() {
      return this.currentPayload.trends.length % 2 === 0;
    },

    trendBlockWithoutFirst() {
      return this.currentPayload.trends.slice(1);
    }

  },

  mounted() {
    this.mobile = this.isMobile();
  },

  methods: {
    stateRelease(arg) {
      const dateRelease = new Date(arg);
      const now = new Date();

      if (dateRelease < now) {
        return true;
      }

      return false;
    },

    pad(s) {
      return s < 10 ? "0".concat(s) : s;
    },

    convertDate(arg) {
      if (arg) {
        const d = new Date(arg);
        return [this.pad(d.getDate()), this.pad(d.getMonth() + 1)].join('/');
      }

      return '';
    }

  }
};